// Design v12 (ADR 0020): Profile › API keys and Profile › Telegram, online only. Keys are shown once on creation and
// stored hashed on the server; Telegram stays unavailable until the server has a bot token and a route to Telegram.
import { api } from './client';

export interface ApiKey { id: string; name: string; last4: string; created_at: string; last_used_at: string | null }
export interface NewApiKey extends ApiKey { key: string }

export async function listApiKeys(): Promise<ApiKey[]> {
  const r = await api<{ keys?: ApiKey[] }>('GET', '/me/api-keys');
  return Array.isArray(r?.keys) ? r.keys : [];
}
export async function createApiKey(name: string): Promise<NewApiKey> { return api<NewApiKey>('POST', '/me/api-keys', { name }); }
export async function revokeApiKey(id: string): Promise<void> { await api<void>('DELETE', '/me/api-keys/' + encodeURIComponent(id)); }

export interface TelegramSettings { workspace_id?: string | null; project_id: string | null; list_id: string | null; mode: 'each' | 'tagged'; split: boolean; tags: boolean; files: boolean; replies: boolean }
export interface TelegramState {
  available: boolean; bot_username: string | null; connected: boolean; handle: string | null; since: string | null;
  code: string | null; code_expires_at?: string | null; /** https://t.me/{bot}?start={code} (server-built) */ deep_link?: string | null; settings: TelegramSettings;
}
export async function getTelegram(): Promise<TelegramState> { return api<TelegramState>('GET', '/me/telegram'); }
export async function saveTelegram(settings: Partial<TelegramSettings>): Promise<TelegramState> { return api<TelegramState>('PUT', '/me/telegram', settings); }
export async function newTelegramCode(): Promise<TelegramState> { return api<TelegramState>('POST', '/me/telegram/code'); }
export async function disconnectTelegram(): Promise<TelegramState> { return api<TelegramState>('DELETE', '/me/telegram'); }
export async function testTelegram(): Promise<void> { await api<void>('POST', '/me/telegram/test'); }
